import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUserAuthor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon-user-author",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Union",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 4.5C10.3629 4.5 9.03571 5.82716 9.03571 7.46429C9.03571 9.10142 10.3629 10.4286 12 10.4286C13.6371 10.4286 14.9643 9.10142 14.9643 7.46429C14.9643 5.82716 13.6371 4.5 12 4.5ZM7.53571 7.46429C7.53571 4.99873 9.53444 3 12 3C14.4656 3 16.4643 4.99873 16.4643 7.46429C16.4643 9.92984 14.4656 11.9286 12 11.9286C9.53444 11.9286 7.53571 9.92984 7.53571 7.46429Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M12 15.0714C8.50156 15.0714 5.56008 17.4642 4.72633 20.7035C4.62308 21.1047 4.21419 21.3462 3.81305 21.2429C3.41191 21.1397 3.17042 20.7308 3.27367 20.3297C4.27386 16.4436 7.80056 13.5714 12 13.5714C16.1994 13.5714 19.7261 16.4436 20.7263 20.3297C20.8296 20.7308 20.5881 21.1397 20.1869 21.2429C19.7858 21.3462 19.3769 21.1047 19.2737 20.7035C18.4399 17.4642 15.4984 15.0714 12 15.0714Z",
				fill: "currentColor"
			})]
		})
	})
});
export { SvgIconUserAuthor as ReactComponent };
